import React, {Fragment} from 'react';
import yup from '../../../lib/YupValidations';
import * as PropTypes from 'prop-types';
import I18n from 'i18n-js';

import Form from '../../shared/Form';
import Button from '../../shared/Button';
import {ForgotPasswordLabel, ForgotPasswordMessage, Wrapper} from './ForgotPasswordForm.styled';
import ResetPasswordForm from '../ResetPasswordForm';
import SupportProposal from '../SupportProposal';

const forgotPasswordByPhoneFields = [
  {
    id: 'phoneNumber',
    label: I18n.t('auth.phoneNumber'),
    name: 'phoneNumber',
    validation: yup.string().required(),
  },
];

const forgotPasswordByEmailFields = [
  {
    id: 'email',
    label: I18n.t('shared.emailAddress'),
    name: 'email',
    validation: yup.string().email().required(),
  }
];


const ForgotPasswordForm = ({
                              resetPassword,
                              resetPasswordByEmail,
                              isForgotPasswordConfirm,
                              isForgotPasswordByEmail,
                              isSupportProposal,
                              isLoading,
                              resetPasswordRequired
                            }) => {
  const showForgotPassword = !isForgotPasswordByEmail && !isForgotPasswordConfirm && !isSupportProposal;
  return (
    <Wrapper>
      {(showForgotPassword) &&
      <Fragment>
        <ForgotPasswordLabel>{resetPasswordRequired ?
          I18n.t('auth.resetPasswordRequiredLabel') :
          I18n.t('auth.forgotPassword')}</ForgotPasswordLabel>
        <ForgotPasswordMessage>{I18n.t('auth.forgotPasswordMessage')}</ForgotPasswordMessage>
        <Form fields={forgotPasswordByPhoneFields} onSubmit={phoneNumber => {
          resetPassword(phoneNumber)
        }}>
          <Button
            disabled={isLoading}
            isLoading={isLoading}
            size={'full'}
            type={'submit'}
          >
            {I18n.t('auth.resetMyPassword')}
          </Button>
        </Form>
      </Fragment>
      }
      {(isForgotPasswordByEmail) &&
      <Fragment>
        <ForgotPasswordLabel>{I18n.t('auth.forgotPasswordByEmail')}</ForgotPasswordLabel>
        <ForgotPasswordMessage>{I18n.t('auth.forgotPasswordByEmailMessage')}</ForgotPasswordMessage>
        <Form fields={forgotPasswordByEmailFields}
              onSubmit={email => {
                resetPasswordByEmail(email)
              }}>
          <Button
            disabled={isLoading}
            isLoading={isLoading}
            size={'full'}
            type={'submit'}
          >
            {I18n.t('auth.resetMyPassword')}
          </Button>
        </Form>
      </Fragment>
      }
      {
        isForgotPasswordConfirm &&
        <ResetPasswordForm isLoading={isLoading}/>
      }
      {(isSupportProposal) &&
      <SupportProposal/>
      }
    </Wrapper>
  )
};

ForgotPasswordForm.propTypes = {
  isForgotPasswordByEmail: PropTypes.bool,
  isForgotPasswordConfirm: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSupportProposal: PropTypes.bool,
  resetPassword: PropTypes.func,
  resetPasswordByEmail: PropTypes.func,
  resetPasswordRequired: PropTypes.any
};

export default ForgotPasswordForm;
